import { NotFound } from "@/components";

export function Page404() {
  return <NotFound />;
}
